(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SeverityDialogController', SeverityDialogController);

    SeverityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Severity'];

    function SeverityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Severity) {
        var vm = this;

        vm.severity = entity;
        //vm.reaction = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.severity.id !== null) {
                Severity.update(vm.severity, onSaveSuccess, onSaveError);
            } else {
                Severity.save(vm.severity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:severityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
